import { useState } from "react";

export const useFilters = () => {
  const [statusFilter, setStatusFilter] = useState("All");
  const [mappingFilter, setMappingFilter] = useState("All");

  return {
    statusFilter,
    setStatusFilter,
    mappingFilter,
    setMappingFilter,
  };
};
